import { render } from "./ViewCustomPages.vue?vue&type=template&id=61f32a8a&scoped=true"
import script from "./ViewCustomPages.vue?vue&type=script&lang=js"
export * from "./ViewCustomPages.vue?vue&type=script&lang=js"

import "./ViewCustomPages.vue?vue&type=style&index=0&id=61f32a8a&scoped=true&lang=css"
import "./ViewCustomPages.vue?vue&type=style&index=1&id=61f32a8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f32a8a"]])

export default __exports__